//
//  data-module.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import { Module } from 'vuex';
import { AppLanguages } from '@/utils/handlers/app-language-handler';

const dataModule: Module<any, any> = {

    namespaced: true,

    state: {

        backgroundOnLoading: true,
        backgroundUrl: undefined,
        appLanguage: undefined,

    },

    mutations: { // sync

        setBackgroundOnLoading(state, value: boolean): void {
            state.backgroundOnLoading = value;
        },

        setBackgroundUrl(state, url: string): void {

            state.backgroundUrl = url;

        },

        setAppLanguage(state, language: AppLanguages): void {

            state.appLanguage = language;

        },

    },

    actions: { // transforms sync mutations to async

    },

};

export default dataModule;
